module.exports = __webpack_public_path__ + "img/TV_clean_box28.589680da.jpg";